module.exports = __webpack_public_path__ + "static/media/ContractClosure – Arabic.13fc9aa9.jpg";